import { getLang } from "helpers/themeHelpers";
import { ISalesUrlParams } from "pages/sales-representatives";
import { qsStringify } from "helpers/globalHelpers";

export function linkSalesRepresentativesIndex(params: ISalesUrlParams = null) {
  const { page = null, cityId = null, category = null } = params || {};
  const locale = getLang();
  const part1 = locale === "ar" ? "مندوبي-المبيعات" : "sales-representatives";
  const queryString = qsStringify({ page, cityId, category });
  return `/${locale}/${part1}${queryString}`;
}
